type THandler<T, R> = (value: T, index: number, array: T[]) => R;

const isFunction = (fn: any) => typeof fn === 'function';

export default async function promiseIterator<T, R>(list: T[], handler: THandler<T, R>) {
  const _handler = isFunction(handler)
    ? handler // 传入的callback
    : (cb: T) => {
      // 没有传入callback，但是每个item可为一个function
      return isFunction(cb) ? (cb as unknown as () => T)() : cb;
    };
  const res = [];
  try {
    for (let i = 0; i < list.length; i++) {
      // eslint-disable-next-line no-await-in-loop
      res.push(await _handler(list[i], i, list));
    }
  } catch (e) {
    console.error('promiseIterator=error=', e);
  }
  return res;
}
